var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',_vm._l((_vm.breadcrumbsList),function(breadcrumb,idx){return _c('b-breadcrumb-item',{key:idx,attrs:{"text":idx === 0 ? _vm.$t(breadcrumb.text) : breadcrumb.text,"active":!breadcrumb.link,"href":breadcrumb.link},on:{"click":function($event){$event.preventDefault();return _vm.routeTo(idx)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d61092ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Breadcrumbs.vue
// module id = null
// module chunks = 